<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faComment, faDog, faSatelliteDish } from '@fortawesome/pro-regular-svg-icons';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { computed } from 'vue';
import FontAwesomeIcon from '../../FontAwesomeIcon.vue';

const props = defineProps<{
  node: {
    attrs: {
      href: string | null;
      target: string;
      'data-title': string | null;
      'data-type': string | null;
      'data-icon': string | null;
      'data-id': string | null;
      'data-repository': string | null;
      'data-channel-code': string | null;
      'data-message-id': string | null;
      'data-project': string | null;
    };
  };
}>();

// Icon registry - matches the one in richTextRichLink.ts
const ICON_REGISTRY: Record<string, IconDefinition> = {
  github: faGithub,
  chat: faComment,
  datadog: faDog,
  sentry: faSatelliteDish,
};

const icon = computed(() => {
  const iconName = props.node.attrs['data-icon'];
  return (iconName && ICON_REGISTRY[iconName]) || faGithub;
});

const displayTitle = computed(() => props.node.attrs['data-title'] || '');
</script>

<template>
  <NodeViewWrapper
    as="a"
    :href="node.attrs.href"
    :target="node.attrs.target"
    :data-title="node.attrs['data-title']"
    :data-type="node.attrs['data-type']"
    :data-icon="node.attrs['data-icon']"
    :data-id="node.attrs['data-id']"
    :data-repository="node.attrs['data-repository']"
    :data-channel-code="node.attrs['data-channel-code']"
    :data-message-id="node.attrs['data-message-id']"
    :data-project="node.attrs['data-project']"
    class="border border-[--tml-chat-message-rich-tag-border-color] bg-[--tml-chat-message-rich-tag-background-color] text-[--tml-chat-message-rich-tag-text-color] px-[--tml-chat-message-rich-tag-padding-x] text-sm rounded-[--tml-chat-message-rich-tag-border-radius] whitespace-nowrap inline-flex items-center"
  >
    <FontAwesomeIcon :icon="icon" class="mr-1" style="width: 14px; height: 14px" />
    {{ displayTitle }}
  </NodeViewWrapper>
</template>
